<!-- External Link -->
<ng-container *ngIf="isExternalLink">
	<a *ngIf="trackEvent" [ngClass]="class" class="cta-link" target="_blank" [href]="link" custom-tracking [attr.data-link-event]="trackEvent">
		<ng-container *ngTemplateOutlet="contents"></ng-container>
	</a>
	<a *ngIf="!trackEvent" [ngClass]="class" class="cta-link" target="_blank" [href]="link">
		<ng-container *ngTemplateOutlet="contents"></ng-container>
	</a>
</ng-container>

<!-- Internal Link -->
<ng-container *ngIf="isInternalLink">
	<a *ngIf="trackEvent" [ngClass]="class" class="cta-link" [routerLink]="link" custom-tracking [attr.data-link-event]="trackEvent">
		<ng-container *ngTemplateOutlet="contents"></ng-container>
	</a>
	<a *ngIf="!trackEvent" [ngClass]="class" class="cta-link" [routerLink]="link">
		<ng-container *ngTemplateOutlet="contents"></ng-container>
	</a>
</ng-container>

<!-- Other -->
<ng-container *ngIf="!link">
	<button *ngIf="trackEvent" [ngClass]="class" class="cta-link" [track-event]="trackEvent">
		<ng-container *ngTemplateOutlet="contents"></ng-container>
	</button>
	<button *ngIf="!trackEvent" [ngClass]="class" class="cta-link">
		<ng-container *ngTemplateOutlet="contents"></ng-container>
	</button>
</ng-container>

<ng-template #contents>
	<icon [type]="icon" *ngIf="icon"></icon>
	<span class="text text-bold">
		<ng-content></ng-content>
	</span>
</ng-template>
